import { MessagePartnerInterface } from '@platri/df-common-core';
import { MessageInterface } from '@platri/df-common-chat-plug-play';

export interface ChatInterface {
  user: MessagePartnerInterface | undefined;
  lastMessage: MessageInterface;
}
